import { render, staticRenderFns } from "./editor-saved-replies.vue?vue&type=template&id=9a80a6b6&"
import script from "./editor-saved-replies.vue?vue&type=script&lang=ts&"
export * from "./editor-saved-replies.vue?vue&type=script&lang=ts&"
import style0 from "./editor-saved-replies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports